const config = {
  VERSION: '2.0 BETA',
  YEAR: new Date().getFullYear(),
  PUBLIC_ROOT: '/',

  zIndex: {
    Progress: 9,
    Portrait: 8,
    Drawer: 7,
    DrawerBackdrop: 6
  }
};

export default config;

